export default "__VITE_ASSET__DSSwoDup__"